import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getReportUsersRequest = () => ({
  type: 'GET_REPORT_USERS_REQUEST',
})

export const getReportUsersSuccess = (data) => ({
  type: 'GET_REPORT_USERS_SUCCESS',
  data,
})

export const getReportUsersFailure = (error) => ({
  type: 'GET_REPORT_USERS_FAILURE',
  error,
})

export const getReportUsers = () => {
  return (dispatch) => {
    dispatch(getReportUsersRequest())

    fetch(URL.BASE_URL + URL.END_POINT.reportusers, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getReportUsersSuccess(data))
      })
      .catch((error) => {
        dispatch(getReportUsersFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialAppState = {
  reportUsersData: [],
  loadingReportUsersData: false,
  errorReportUsersData: null,
}

const reportUsersReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case 'GET_REPORT_USERS_REQUEST':
      return {
        ...state,
        loadingReportUsersData: true,
        errorReportUsersData: null,
      }
    case 'GET_REPORT_USERS_SUCCESS':
      return {
        ...state,
        reportUsersData: action.data,
        loadingReportUsersData: false,
        errorReportUsersData: null,
      }
    case 'GET_REPORT_USERS_FAILURE':
      return {
        ...state,
        loadingReportUsersData: false,
        errorReportUsersData: action.error,
      }
    default:
      return state
  }
}

export default reportUsersReducer
